import { View, StyleSheet } from "react-native";
import BlankLayout from "../layouts/BlankLayout";
import SignupFormContainer from "../containers/auth/SignupFormContainer/SignupFormContainer";
import useResponsiveScreen from "../hooks/useResponsiveScreen";
import { ScrollView } from "react-native-gesture-handler";

function SignupView(isLMS = false) {
  const { isLarge } = useResponsiveScreen();

  return (
    <BlankLayout flexDirection="column">
      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={true}>
        {isLarge ? (
          <View style={[styles.webContainer, { width: !isLMS ? "40%" : "100%" }]}>
            <SignupFormContainer />
          </View>
        ) : (
          <View style={styles.mobileContainer}>
            <View style={{ padding: 15 }}>
              <SignupFormContainer />
            </View>
          </View>
        )}
      </ScrollView>
    </BlankLayout>
  );
}

const styles = StyleSheet.create({
  webContainer: {
    justifyContent: "center",
    alignItems: "center",
    padding: 30,
  },
  mobileContainer: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  scrollView: {
    height: 20,
  },
});

export default SignupView;
